import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import { getTranslatedOptions } from '../../../../utils/translation'
import { ActionSelect } from '../../../Action'
import { TableCellBase } from '../../../Table'
import { QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ROW_ACTIONS } from '../RequestProfileTabActivities.constants'

import * as styles from './RequestProfileTabActivitiesTableActionsCell.module.css'

function RequestProfileTabActivitiesTableActionsCell({
  actions = EMPTY_LIST,
  item,
  onCallAction,
  ...restProps
}) {
  const { t } = useTranslation()

  const translatedActions = getTranslatedOptions({
    options: actions ?? EMPTY_LIST,
    t,
  })

  function handleClickAction(action) {
    onCallAction?.(action?.value, item)
  }

  return (
    <TableCellBase {...restProps} className={styles.cell}>
      {translatedActions.length > 0 ? (
        <ActionSelect
          actions={translatedActions}
          controlProps={{
            buttonProps: {
              qaName: QA_NAME_REQUEST_PROFILE_TAB_ACTIVITIES_ROW_ACTIONS,
            },
          }}
          onClickAction={handleClickAction}
        />
      ) : null}
    </TableCellBase>
  )
}

export default RequestProfileTabActivitiesTableActionsCell
